module.exports = __webpack_public_path__ + "img/Plataforma_de_gestao.225371d.svg";